import { connect } from 'react-redux';

import { invoiceFixBidConfig } from '../../../entity/projects/invoiceFixBidConfig';
import BaseComponent from '../../../components/BaseComponent';

class FixedBidInvoice extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...invoiceFixBidConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(FixedBidInvoice);
